<template>
    <v-row>
        <v-col>
            <v-row>
                <v-col>
                    <v-row v-for="(condition, index) in conditions" :key="index" align="center" class="ml-1">
                        <v-col>
                            <v-card outlined class="pa-3 mb-2">

                                <v-row align="center">
                                    <v-col>
                                        <span class="font-weight-bold">
                                            {{ index === 0 ? 'SE' : 'SENÃO SE' }}
                                        </span>
                                    </v-col>
                                </v-row>

                                <template v-if="index === 0 || condition.rules.length > 0">
                                    <v-row v-for="(rule, rIndex) in condition.rules" :key="rIndex" no-gutters
                                        align="center">
                                        <v-col v-if="rIndex > 0" cols="12" sm="2">
                                            <v-select class="mr-2" dense :items="logicOperators"
                                                v-model="rule.logicOperator" item-value="id" item-text="label"
                                                label="Lógica" outlined hide-details="auto"></v-select>
                                        </v-col>

                                        <v-col v-if="mainReport" cols="12" sm="3">
                                            <v-select class="mr-2" dense
                                                :items="mainReport ? mainReport.type.columns : []" item-value="id"
                                                item-text="label" v-model="rule.whenColumn" label="Coluna" outlined
                                                hide-details="auto"></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="2">
                                            <v-select class="mr-2" dense :items="operators" v-model="rule.whenOperator"
                                                item-value="id" item-text="label" label="Operador" outlined
                                                hide-details="auto"></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="2">
                                            <v-checkbox label="Comparar com relatório"
                                                v-model="rule.isCompareReport"></v-checkbox>
                                        </v-col>

                                        <template v-if="rule.isCompareReport">
                                            <v-col cols="12" sm="3">
                                                <v-select class="mr-2" dense :items="dataset.reports" item-value="id"
                                                    item-text="name" v-model="rule.compareReport" return-object
                                                    label="Relatório" outlined hide-details="auto">
                                                </v-select>
                                            </v-col>
                                            <v-col v-if="rule.compareReport" cols="12" sm="3">
                                                <v-select class="mr-2" dense :items="rule.compareReport.type.columns"
                                                    item-value="id" item-text="label" v-model="rule.compareColumn"
                                                    label="Coluna" outlined hide-details="auto"></v-select>
                                            </v-col>
                                        </template>

                                        <v-col v-if="!rule.isCompareReport" cols="12" sm="3">
                                            <v-text-field class="mr-1" dense v-model="rule.whenValue" label="Valor"
                                                outlined hide-details="auto"></v-text-field>
                                        </v-col>

                                        <v-col v-if="rIndex > 0" cols="12" sm="1">
                                            <v-btn color="error" icon small
                                                @click="removeRule(condition.rules, rIndex)">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>

                                <v-row>
                                    <v-col>
                                        <v-btn color="accent" class="mr-2" small @click="addRule(condition.rules, 'E')">
                                            Adicionar E
                                        </v-btn>
                                        <v-btn color="cyan" small @click="addRule(condition.rules, 'OU')">
                                            Adicionar OU
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <span class="font-weight-bold">ENTÃO</span>
                                    </v-col>
                                </v-row>

                                <v-row class="mt-4" no-gutters align="center">
                                    <template v-if="condition.conditions.length === 0">
                                        <v-col cols="12" sm="3">
                                            <v-select class="mr-2" dense :items="dataset.reports" item-value="id"
                                                item-text="name" v-model="condition.thenReport" return-object
                                                label="Relatório (opcional)" outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col v-if="condition.thenReport" cols="12" sm="3">
                                            <v-select class="mr-2" dense
                                                :items="condition.thenReport ? condition.thenReport.type.columns : []"
                                                item-value="id" item-text="label" v-model="condition.thenColumnValue"
                                                label="Coluna valor" outlined hide-details="auto"></v-select>
                                        </v-col>
                                        <v-col v-if="condition.thenReport" cols="12" sm="3">
                                            <v-select dense
                                                :items="condition.thenReport ? condition.thenReport.type.columns : []"
                                                item-value="id" item-text="label"
                                                v-model="condition.thenColumnAssociation" label="Coluna associação"
                                                outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col v-if="!condition.thenReport" cols="12" sm="3">
                                            <v-text-field class="mr-1" dense v-model="condition.thenValue" label="Valor"
                                                outlined hide-details="auto"></v-text-field>
                                        </v-col>
                                    </template>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <v-btn v-if="condition.conditions.length === 0" color="#1E88E5"
                                            class="white--text" small @click="addCondition(condition.conditions)">
                                            Adicionar Subcondição
                                        </v-btn>

                                        <v-btn v-if="conditions.length > 1 || isNested" color="error" icon
                                            @click="removeCondition(conditions, index)">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <ConditionGroup v-if="condition.conditions.length" :mainReport="mainReport"
                                    :conditions="condition.conditions" :dataset="dataset" :operators="operators"
                                    :isNested="true" />

                                <v-row>
                                    <v-col>
                                        <span class="font-weight-bold">SENÃO</span>
                                    </v-col>
                                </v-row>

                                <v-row class="mt-4" no-gutters align="center">
                                    <template>
                                        <v-col cols="12" sm="3">
                                            <v-select class="mr-2" dense :items="dataset.reports" item-value="id"
                                                item-text="name" v-model="condition.elseReport" return-object
                                                label="Relatório (opcional)" outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col v-if="condition.elseReport" cols="12" sm="3">
                                            <v-select class="mr-2" dense
                                                :items="condition.elseReport ? condition.elseReport.type.columns : []"
                                                item-value="id" item-text="label" v-model="condition.elseColumnValue"
                                                label="Coluna valor" outlined hide-details="auto"></v-select>
                                        </v-col>
                                        <v-col v-if="condition.elseReport" cols="12" sm="3">
                                            <v-select dense
                                                :items="condition.elseReport ? condition.elseReport.type.columns : []"
                                                item-value="id" item-text="label"
                                                v-model="condition.elseColumnAssociation" label="Coluna associação"
                                                outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col v-if="!condition.elseReport" cols="12" sm="3">
                                            <v-text-field class="mr-1" dense v-model="condition.thenValue" label="Valor"
                                                outlined hide-details="auto"></v-text-field>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ConditionGroup",
    props: ["conditions", "dataset", "operators", "mainReport", "isNested"],
    data() {
        return {
            logicOperators: [
                { id: "E", label: "E" },
                { id: "OU", label: "OU" },
            ],
        };
    },
    methods: {
        addCondition(parentConditions) {
            parentConditions.push({
                rules: [
                    {
                        logicOperator: null,
                        whenReport: null,
                        whenColumn: null,
                        whenOperator: null,
                        whenValue: null,
                        isCompareReport: false,
                        compareReport: null,
                        compareColumn: null,
                    }
                ],
                thenReport: null,
                thenColumnValue: null,
                thenColumnAssociation: null,
                elseReport: null,
                elseColumnValue: null,
                elseColumnAssociation: null,
                conditions: [],
            });
        },
        addRule(parentRules, operator) {
            parentRules.push({
                logicOperator: operator,
                whenReport: null,
                whenColumn: null,
                whenOperator: null,
                whenValue: null,
                isCompareReport: false,
                compareReport: null,
                compareColumn: null,
            });
        },
        removeRule(parentRules, index) {
            parentRules.splice(index, 1);
        },
        removeCondition(parentConditions, index) {
            parentConditions.splice(index, 1);
        },
    },
};
</script>